<template>
    <b-modal
      id="downloadFileModal"
      :centered="true"
      title="Download Claim"
      :hide-footer="true"
      @shown="getDownloadFiles"
      size="lg"
      hide-header-close
      no-close-on-backdrop
    >
      <b-button variant="close-btn" class='btn-container' @click="closeModal">
        <i class="fas fa-times"></i>
      </b-button>
      <div class="table-responsive">
        <table class="table w-100">
          <thead class="">
            <tr>
              <th style="border-top: 0">File name</th>
              <th style="border-top: 0">Download</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(file, index) in files" :key="index">
              <td class="file-name-download">{{ file.filename }}</td>
              <td class="">
                <div
                style="cursor: pointer;"
                  class="action-download"
                  v-b-tooltip.hover
                  title=""
                  @click="downloadFile(file.url)"
                >
                  <i class="fas fa-download"></i>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
  </template>
  
  <script>
  import axios from "axios";
  export default {
    data() {
      return {
        files: [],
      };
    },
    props:{
      userId:{
        required:true
      }
    },
    methods: {
      downloadFile(link) {
        window.open(link, "_blank");
      },
      getDownloadFiles() {
        let loader = this.$loading.show();
        let url = `v2/prudential-claim/get-prudential-form?user_id=${this.userId}`;
        axios
          .get(url)
          .then((res) => {
            if (res.data.status === "success") {
              this.files = res.data.data;
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            loader.hide();
          });
      },
      closeModal() {
        this.$bvModal.hide("downloadFileModal");
      },
    },
  };
  </script>
  <style>
    .file-name-download{
      padding-top: 0.75rem !important;
    }
    #downloadFileModal .btn-container  {
      position: absolute;
      top: -80px !important;
      right: -15px;
      background: #fff;
      color: #000;
      border: 0;
      box-shadow: -2px 2px 13px -4px rgb(0 0 0 / 46%);
      border-radius: 60px;
      font-size: 18px;
      width: 45px;
      height: 45px;
      align-items: center;
      justify-content: center;
      display: flex;
    }
  </style>